
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-14e48463&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DashboardLayout.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-14e48463!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./DashboardLayout.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DashboardLayout.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-14e48463!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DashboardLayout.vue"),
  /* scopeId */
  "data-v-14e48463",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/buybox/DashboardLayout.vue
// module id = 25
// module chunks = 2